import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UserPermission as GenesysUserPermission } from 'common/store/genesys-cloud/users/models/user-permission.enum';
import { Focusable } from 'shared/models/focus/focus.model';

@Component({
  selector: 'app-genesys-chat-buttons',
  templateUrl: './genesys-chat-buttons.component.html',
  styleUrls: ['./genesys-chat-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenesysChatButtonsComponent implements Focusable {
  readonly gcUserPermission = GenesysUserPermission;

  @ViewChild('focusTarget')
  focusTarget: ElementRef<HTMLElement>;

  @Input()
  isExpandedMode = false;
  @Input()
  disableButtons = false;
  @Input()
  isCobrowseActive: boolean;
  @Output()
  readonly endChat = new EventEmitter<void>();
  @Output()
  readonly sendWrapUp = new EventEmitter<void>();
  @Output()
  readonly openTransferPanel = new EventEmitter<void>();

  focus(): void {
    setTimeout(() => {
      this.focusTarget.nativeElement.focus();
    }, 0);
  }
}
